import { useContext } from 'react';
import { TournamentContext } from '@/contexts/tournament/TournamentContext';
import { TournamentContextType } from '@/contexts/tournament/types';

export function useTournament() {
  const context = useContext(TournamentContext);
  if (!context) {
    console.error('useTournament called outside of TournamentProvider');
    throw new Error("useTournament must be used within a TournamentProvider");
  }
  return context;
}
